// extracted by mini-css-extract-plugin
export default {"domainSelect":"CountriesHeader_domainSelect__c5Tzh"};